import { Component, ComponentType, createContext, FC, useContext } from 'react';

export const LiveAuctionContext = createContext({});

export const LiveAuctionProvider: FC = props => {
	return <LiveAuctionContext.Provider value={{}} {...props} />;
};

export const withLiveAuctionProvider = (Component: ComponentType) => props => <LiveAuctionProvider>
	<Component {...props} />
</LiveAuctionProvider>;

export const useLiveAuctionContext = () => useContext(LiveAuctionContext);
